export const GAMES_GRID_TEST_ID = 'games-grid'
export const CATEGORIES_GRID_TEST_ID = 'categories-grid'
